<template>
  <div class="">
    <div class="container px-4 pb-4 bg-white mt-5 filter rounded">
      <h1 class="pt-3 mb-4 h1--title">Vacantes</h1>

      <div>
        <h2 class="h2--title">Crear vacantes</h2>
        <hr />
        <CreateVacant
          @handleCreateVacant="CreateVacant"
          :cleanForm="cleanForm"
        />
      </div>
    </div>
    <div class=" pt-4 container px-4 pb-4 bg-white mt-4 filter rounded">
      <h2 class="h2--title">Listado de vacantes</h2>
      <hr />
      <ListVacant />
    </div>
  </div>
</template>
<script>
import CreateVacant from "../components/Vacants/CreateVacant";
import ListVacant from "../components/Vacants/ListVacants";

export default {
  components: {
    CreateVacant,
    ListVacant,
  },
  data() {
    return {
      cleanForm: new Date(),
    };
  },

mounted(){

},
  methods: {
    CreateVacant(data) {
    this.$loading.show()
      this.$store
        .dispatch({ type: "vacant/createVacant", data })
        .then( async (resp) => {
          this.$swal.fire("Éxito", resp.message, "success");
          this.cleanForm = new Date();
         await  this.$store.dispatch({
            type: "vacant/getVacants",
            data: this.$store.state.vacant.requestListVacants,
          });
          this.$loading.hide()
        })
        .catch((e) => {
          this.$loading.hide()
          this.$swal.fire("Error", e.message, "error");
        });
    },
  },
};
</script>
<style>
body {
  background-image: url("../assets/vuesax-login-bg.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
